export enum $paginationParams {
  sortBy = 'sortBy',
  direction = 'direction',
  pageNumber = 'pageNumber',
  pageSize = 'pageSize',
}
